import React, { useEffect, useState } from "react";
import { Navbar } from "react-bootstrap";
import PropTypes from "prop-types";
import { Button } from "../Buttons/Button";
import profileLogo from '../../assets/icons/person.svg'

/**
 * Header component renders the header section of the application.
 * @param {Object} props - Props for the Header component.
 * @param {string} props.title - Title content for the header.
 * @returns {JSX.Element} - Rendered component.
 */

const Header = ({ title, isActivation, userInitials }) => {
  /* Array of dropdown items */
  const [items, setItems] = useState([
    { label: "Manage account", href: "/account" },
    { label: "Change password", href: "/change-password" },
  ]);

  const [initials, setInitials] = useState("");
  const [userName, setUserName] = useState("");

  /* Function to extract initials from username */
  const getInitials = (name) => {

    if (!name || typeof name !== "string" || !name.trim()) {
      return undefined; // Return undefined for empty, null, or undefined names
    }

    const nameParts = name.trim().split(/\s+/); // Split by spaces, handling multiple spaces

    if (nameParts.length < 2) {
      return undefined; // If there's only one part or it's incomplete, return undefined
    }

    return (
      (nameParts[0]?.charAt(0)?.toUpperCase() || undefined) +
      (nameParts[1]?.charAt(0)?.toUpperCase() || undefined)
    );
  };

  // Function to make string to sentence case
  const toSentenceCase = (str) => {
    if (str.length === 0) return "";
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

const convertPageTitle = (input) => {
  if (!input) return "";

  // Handle JSX/React elements — return as-is
  if (typeof input === "object" && input?.$$typeof) return input;

  // Handle string
  if (typeof input === "string") {
    return input.charAt(0).toUpperCase() + input.slice(1);
  }

  // Handle number, boolean, etc. — convert to string first
  return String(input).charAt(0).toUpperCase() + String(input).slice(1);
};

  /* Function to store initials using getInitials method */
  useEffect(() => {
    if (userInitials) {
      const user = getInitials(userInitials);
      const fullName = toSentenceCase(userInitials.split("@")[0]);
      setInitials(user);
      setUserName(fullName);
    }
  }, [userInitials]);


  // change request for MFA disabled 
  // useEffect(() => {
  //   // Check localStorage for MFA status
  //   const mfaEnabled = JSON.parse(localStorage.getItem("mfa_enabled"));
  //   if (mfaEnabled === false) {
  //     setItems((prevItems) => {
  //       // Check if the item already exists to avoid duplicates
  //       const itemExists = prevItems.some(
  //         (item) => item.label === "Enable MFA",
  //       );
  //       if (!itemExists) {
  //         return [...prevItems, { label: "Enable MFA", href: "/enable-otp" }];
  //       }
  //       return prevItems;
  //     });
  //   }
  // }, []);

  return (
    <>
      {/* Navbar component for the header */}
      <Navbar>
        <div className="page-header pt-4 w-100">
          {/* Title content */}
          <h1 className="patient-title">{convertPageTitle(title)}</h1>
          {!isActivation && (
            <div className="btn-toolbar mb-2 mb-md-0">
              <div className="dropdown profile-dropdown-wrapper">
  
                {/* Profile button with initials */}
                <Button
                  className="btn btn-profile"
                  initials={initials}
                  items={items}
                  label={initials}
                  svg={!initials ? profileLogo : null}
                  type="dropdown"
                  username={userName}
                  variant="gray"
                >
                  {" "}
                </Button>
              </div>
            </div>
          )}
        </div>
      </Navbar>
    </>
  );
};

/* Define PropTypes for the Header component */
Header.propTypes = {
  title: PropTypes.string.isRequired,
  isActivation: PropTypes.bool,
  userInitials: PropTypes.string,
};

export default Header;
